import { Box, Grid, Typography } from "@mui/material";
import React from "react";

import PinkButton from "../../components/customButtons/PinkButton";

export default function NewPage403() {
  return (
    <>
      <Grid
        container
        spacing={2}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        width="100%"
      >
        <Box width={548}>
          <img src="/newdashboard/ErrorPageIcons/Group 1171282955.png" />
        </Box>

        <Typography
        mt={2}
          color="#000000"
          fontFamily="Inter"
          fontSize="26px"
          letterSpacing="0px"
          style={{ fontWeight: 700 }}
        >
          {" "}
         Forbidden 
        </Typography>

        <Typography
          color="#000000"
          fontFamily="Inter"
          fontSize="20px"
          mt={2}
          letterSpacing="0px"
          textAlign="center"
          style={{ fontWeight: 400 }}
        >
          {" "}
          Access denied. You don't have permission to perform this action.
        </Typography>

        <Box mt={3}>
          <PinkButton
            buttonTitle="Retry"
            startIcon={<img src="/newdashboard/ErrorPageIcons/fa_repeat.png" />}
          />
        </Box>
      </Grid>
    </>
  );
}
